import React from 'react';
import Button from '../../components/Button';
import ContainerPage from '../../components/ContainerPage';
import HeadTitle from '../../components/HeadTitle';
import CancelModal from './componets/CancelModal';

import * as S from './styles';
import { useContextSelector } from 'use-context-selector';
import LoadingOverlay from '../../components/LoadingOverlay';
import { PlatformContext } from '../../contexts/PlatformContext';
import { specialistAppointment } from '../../models/specialistAppointment';
import { AppointmentSGH } from './componets/AppointmentSGH';
import { AppointmentSpecialist } from './componets/AppointmentSpecialist';

export type AppointmentInfo = {
  id: string | number;
  careType: 'PRESENTIAL' | 'EINSTEIN_TO_YOU' | 'TELEMEDICINE' | 'DRIVE_THRU';
  verificationCode: string;
  scheduleType: 'IMMUNIZATION' | 'EXAM' | 'CONSULTATION';
  date: string;
  hour: string;
  service: string;
  status: string;
  unit?: {
    name: string;
    addressLine1: string;
    addressLine2: string;
  };
  resource?: {
    id: string;
    name: string;
    crm: string;
    role?: string;
  };
  weekDay: string;
  virtualAppointmentUrl: string;
  patient: {
    isPregnant: boolean;
  };
  product: {
    name: string;
  };
};

export enum CareTypes {
  PRESENTIAL = 'PRESENTIAL',
  EINSTEIN_TO_YOU = 'EINSTEIN_TO_YOU',
  TELEMEDICINE = 'TELEMEDICINE',
  DRIVE_THRU = 'DRIVE_THRU'
}

export const CARE_TYPES_MAPPED = {
  PRESENTIAL: 'Presencial',
  EINSTEIN_TO_YOU: 'Einstein até você',
  TELEMEDICINE: 'Consulta telemedicina',
  DRIVE_THRU: 'Drive-thru'
};

export const SCHEDULES_TYPES_MAPPED = {
  APPOINTMENT: 'Consulta equipe de cuidado',
  CONSULTATION: 'Consulta equipe de cuidado',
  EXAM: 'Exame',
  IMMUNIZATION: 'Vacina'
};

type AppointmentDetailsProps = { appointment: any };

const AppointmentDetails = ({ appointment: appointmentState }: AppointmentDetailsProps) => {
  const [isCancelModalVisible, setIsCancelModalVisible] = React.useState(false);
  const [appointment, setAppointment] = React.useState<AppointmentInfo>();
  const [specialistAppointment, setSpecialistAppointment] = React.useState<specialistAppointment>();
  const [loading, setLoading] = React.useState(false);
  const { setIsSchedulerOpen } = useContextSelector(PlatformContext, state => state);

  React.useEffect(() => {
    if (appointmentState) {
      if (appointmentState.specialist) setSpecialistAppointment(appointmentState);
      else setAppointment(appointmentState);
    }
  }, []);

  return (
    <>
      <ContainerPage
        childrenFooter={
          <Button
            title="Cancelar agendamento"
            type="button"
            onClick={() => {
              setIsCancelModalVisible(true);
            }}
          />
        }
      >
        <S.Container>
          <HeadTitle title="Detalhes agendamento" />
          {appointment && (
            <S.Schedule>
              <AppointmentSGH appointment={appointment} />
            </S.Schedule>
          )}
          {specialistAppointment && (
            <S.Schedule>
              <AppointmentSpecialist appointment={specialistAppointment} />
            </S.Schedule>
          )}
        </S.Container>
        <LoadingOverlay loading={loading} />
      </ContainerPage>
      <CancelModal
        visible={isCancelModalVisible}
        onClose={() => setIsSchedulerOpen(false)}
        scheduleId={appointment?.id || specialistAppointment?.id || ''}
        verificationCode={appointment?.verificationCode || specialistAppointment?.token || ''}
        setLoading={setLoading}
        specialist={!!specialistAppointment?.id}
        specialistAppointment={specialistAppointment}
      />
    </>
  );
};

export default AppointmentDetails;
